const SLUG = "outsourced-financial-management";

const STEPS = [
  {
    title: "Tell us about your business",
    text: "A few details about your size, your current finance setup and what you need covered.",
  },
  {
    title: "We scope the function",
    text: "We work through the tasks, how often support is needed and what T-TITE takes responsibility for.",
  },
  {
    title: "We recommend the team",
    text: "The right mix of Financial Manager, Accountant and finance support for the work in front of us.",
  },
  {
    title: "You receive a tailored proposal",
    text: "A defined scope, team structure, responsibilities and monthly fee — before anything begins.",
  },
];

/** Four steps from first enquiry to an agreed proposal. */
export const HowItWorks = () => (
  <section data-testid={`${SLUG}-how-it-works`} className="py-14 sm:py-20">
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <h2 className="text-[27px] font-bold leading-[1.15] tracking-[-0.015em] text-foreground sm:text-[34px]">
        How it works
      </h2>

      <ol className="relative mt-10 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
        <span
          aria-hidden="true"
          className="absolute left-0 top-[19px] hidden h-px w-full bg-border lg:block"
        />
        {STEPS.map(({ title, text }, index) => (
          <li
            key={title}
            data-testid={`${SLUG}-step-${index + 1}`}
            className="relative flex gap-4 lg:block"
          >
            <span className="font-amount relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[color:var(--tt-accent)]/30 bg-white text-[13px] font-semibold text-[color:var(--tt-accent)]">
              {String(index + 1).padStart(2, "0")}
            </span>
            <div className="lg:mt-5">
              <h3 className="text-[14.5px] font-bold leading-snug text-foreground">{title}</h3>
              <p className="mt-2 max-w-[34ch] text-[13.5px] leading-relaxed text-muted-foreground">
                {text}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
